<template>
  <div>
    <v-tour
      v-if="language == 'Nederlands'"
      name="ProjectTour"
      :steps="projects != null ? stepswithNED : stepswithoutNED"
      :callbacks="myCallbacks"
      :options="myOptionsNED"
    ></v-tour>
    <v-tour
      v-else-if="language == 'Chinese'"
      name="ProjectTour"
      :steps="projects != null ? stepswithCHI : stepswithoutCHI"
      :callbacks="myCallbacks"
      :options="myOptionsCHI"
    ></v-tour>
    <v-tour
      v-else-if="language == 'Portugues'"
      name="ProjectTour"
      :steps="projects != null ? stepswithPOR : stepswithoutPOR"
      :callbacks="myCallbacks"
      :options="myOptionsPOR"
    ></v-tour>
    <v-tour
      v-else
      name="ProjectTour"
      :steps="projects != null ? stepswithENG : stepswithoutENG"
      :callbacks="myCallbacks"
      :options="myOptionsENG"
    ></v-tour>
    <app-header :sysco="sysco"></app-header>

    <div
      class="modal fade"
      id="ConfirmDelete"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("delete_warning")}}</h5>
          </div>
          <div class="modal-body">
            <p>
              <strong>{{projtodelete.customerName}} - {{projtodelete.projectName}}</strong>
            </p>
            <p>{{caption("delete_project_sure")}}</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="projectDelete(projtodelete.id)"
              data-dismiss="modal"
            >{{caption("addwin_Yes")}}</button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >{{caption("addwin_No")}}</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="BomSelection"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("bom_chooseformat")}}</h5>
          </div>
          <div class="modal-body">
            <span>
              <button
                class="btn btn-small btn-outline-primary"
                @click="projectCSV(bomprojid)"
              >{{caption("bom_csv")}}</button>
            </span>
            <span>
              <button
                class="btn btn-small btn-outline-primary"
                @click="projectXL(bomprojid)"
              >{{caption("bom_xlsx")}}</button>
            </span>
            <span>
              <button class="btn btn-small btn-danger" @click="bommodalhide()">{{caption("Cancel")}}</button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="PDFSelection"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("pdf_chooseformat")}}</h5>
          </div>
          <div class="modal-body">
            <div align="middle">
              <button
                :class="firstpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'"
                style="width: 400px"
                @click="setfirstpage()"
              >{{caption("pdf_firstpage")}}</button>
            </div>
            <div align="middle">
              <button
                :class="sashpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'"
                style="width: 400px"
                @click="setsashpage()"
              >{{caption("pdf_sashpage")}}</button>
            </div>
            <div align="middle">
              <button
                :class="framepage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'"
                style="width: 400px"
                @click="setframepage()"
              >{{caption("pdf_framepage")}}</button>
            </div>
            <div class="mt-3" align="middle">
              <span>
                <button
                  class="btn btn-small btn-outline-primary"
                  @click="projectPdfSeparate()"
                >{{caption("pdf_separate")}}</button>
              </span>
              <span>
                <button
                  class="btn btn-small btn-outline-primary"
                  @click="projectPdfBundled()"
                >{{caption("pdf_bundled")}}</button>
              </span>
              <span>
                <button
                  class="btn btn-small btn-danger"
                  @click="pdfmodalhide()"
                >{{caption("Cancel")}}</button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="CopyProjectName"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("addproj_EnterProjectName")}}</h5>
          </div>
          <div class="modal-body">
            <label class="label">{{caption("addproj_ProjectName")}}</label>
            <input type="text" class="input form-control" required v-model.trim="projName" />
            <div class="text-danger" v-if="projEmpty">{{caption("addwin_Required")}}</div>
            <div class="mt-3">
              <span>
                <button
                  class="btn btn-small btn-primary"
                  @click="projCopySend()"
                >{{caption("Submit")}}</button>
              </span>
              <span>
                <button
                  class="btn btn-small btn-danger"
                  @click="projectcopyModalHide()"
                >{{caption("Cancel")}}</button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="SharedUsersSelection"
      tabindex="-1"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("shared_selectusers")}}</h5>
          </div>
          <div class="modal-body">
            <div v-for="usr in shusers" v-bind:key="usr.userId" align="middle">
              <div>
                <button
                  :class="usrinlist(usr.userId) ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'"
                  style="width: 400px"
                  @click="setUser(usr.userId)"
                >
                  <i v-if="readonly(usr.userId) == 1" class="fas fa-lock mr-3"></i>
                  <i v-if="readonly(usr.userId) == 2" class="fas fa-lock-open mr-3"></i>
                  {{usr.firstName}} {{usr.lastName}}, {{usr.companyName}}
                </button>
              </div>
            </div>
            <div class="mt-4" align="middle">
              <span>
                <button
                  class="btn btn-small btn-primary"
                  @click="selectusershide()"
                >{{caption("Submit")}}</button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid" style="background-color: white;">
      <div>
        <span v-if="role == 1 || role == 4 || role == 5 || role == 6">
          <button type="button" class="btn btn-primary btn-sm my-2" @click="users()">Users</button>
        </span>
        <span v-if="versionsloaded = true && (usersVN < latestVN)">
          <button
            type="button"
            class="btn btn-danger btn-sm my-2 v-step-0"
            @click="versions()"
          >{{caption("update_new")}}</button>
        </span>
        <span v-if="versionsloaded = true && (usersVN >= latestVN)">
          <button
            type="button"
            class="btn btn-primary btn-sm my-2 v-step-0"
            @click="versions()"
          >{{caption("update_updates")}}</button>
        </span>
        <span>
          <button
            type="button"
            class="btn btn-info btn-sm my-2"
            @click="starttour"
          >{{caption("tour_tour")}}</button>
        </span>
        <span>
          <button
            type="button"
            class="btn btn-primary btn-sm my-2 v-step-1"
            @click="sharedusers()"
          >{{caption("users_sharedusers")}}</button>
        </span>
        <span>
          <button type="button" class="btn btn-primary btn-sm my-2" @click="downloads()">Downloads</button>
        </span>
        <span v-if="role == 1 || role == 4 || role == 5 || role == 6">
          <button type="button" class="btn btn-primary btn-sm my-2" @click="exportOrgaData()">Export</button>
        </span>
        <span class="dropdown float-right">
          <button
            class="btn btn-secondary btn-sm dropdown-toggle my-2 v-step-2"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >{{language}}</button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="#" @click="changelanguage('Nederlands')">Nederlands</a>
            <a class="dropdown-item" href="#" @click="changelanguage('English')">English</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Français')">Français</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Deutsch')">Deutsch</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Chinese')">Chinese</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Portugues')">Portugues</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Espanol')">Espanol</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Czech')">Czech</a>
            <a class="dropdown-item" href="#" @click="changelanguage('Polski')">Polski</a>
          </div>
        </span>
      </div>
      <div class="display-4">{{caption("projlist_Projects")}}</div>
      <hr />
      <button
        type="button"
        style="font-size: 20px"
        class="btn btn-primary btn-sm mb-2 v-step-3"
        @click="projectCreate()"
      >
        <i class="fas fa-plus-square mr-2"></i>
        {{caption("projlist_AddProject")}}
      </button>
      <button
        type="button"
        style="font-size: 20px"
        class="btn btn-info btn-sm mb-2"
        @click="refresh()"
      >
        <i class="fas fa-sync"></i>
      </button>
      <input
        type="text"
        style="font-size: 16px"
        class="input form-control mb-2 v-step-4"
        v-model="searchproj"
      />
      <span class="dropdown">
        <button
          class="btn btn-secondary btn-sm dropdown-toggle my-2"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >{{caption(sortoptions)}}</button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" href="#" @click="setSort('byName')">{{caption('byName')}}</a>
          <a class="dropdown-item" href="#" @click="setSort('oldnew')">{{caption('oldnew')}}</a>
          <a class="dropdown-item" href="#" @click="setSort('newold')">{{caption('newold')}}</a>
          <a class="dropdown-item" href="#" @click="setSort('lstmod')">{{caption('lstmod')}}</a>
        </div>
      </span>
    </div>

    <div v-if="projectsloaded = true" class="container-fluid">
      <div
        v-for="p in projects"
        v-bind:key="p.Id"
        class="card"
        :style="tour == true ? 'z-index:-1; position:relative' : ''"
      >
        <div class="card-header">
          <div class="card-subtitle mt-0">
            <div class="row">
              <div class="col-lg-5">
                <div class="row">
                  <div v-if="p.sharedCount == null" class="col">
                    <div class="row">
                      <div>
                        <span
                          :class="p.numWindows > 0 ? 'badge badge-primary v-step-5 ml-4' : 'badge badge-danger ml-4 v-step-5'"
                        >{{p.numWindows}}</span>
                        <span class="ml-3" style="color:blue">
                          <small>{{p.customerName}}</small>
                        </span>
                        <span class="ml-1">
                          <strong>{{p.projectName}}</strong>
                        </span>
                        <div class="my-1 ml-4 small">
                          <i class="far fa-plus-square mr-1"></i>
                          {{getDateTime(p.createdDate)}}
                        </div>
                        <div class="my-1 ml-4 small">
                          <i class="far fa-edit mr-1"></i>
                          {{getDateTime(p.lastModifiedDate)}}{{p.lastModifiedUser != p.userId && p.lastModifiedUser != 0 ? ' (' + getuserinfo(p.lastModifiedUser) + ')' : ''}}
                          <i
                            v-if="p.lastModifiedUser == p.userId"
                            class="far fa-user ml-1 mr-1"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="p.sharedCount == 0" class="col">
                    <div class="row">
                      <div>
                        <span
                          :class="p.numWindows > 0 ? 'badge badge-primary v-step-5 ml-4' : 'badge badge-danger ml-4 v-step-5'"
                        >{{p.numWindows}}</span>
                        <span class="ml-3" style="color:blue">
                          <small>{{p.customerName}}</small>
                        </span>
                        <span class="ml-1">
                          <strong>{{p.projectName}}</strong>
                        </span>
                        <div class="my-1 ml-4 small">
                          <i class="far fa-plus-square mr-1"></i>
                          {{getDateTime(p.createdDate)}}
                        </div>
                        <div class="my-1 ml-4 small">
                          <i class="far fa-edit mr-1"></i>
                          {{getDateTime(p.lastModifiedDate)}}
                        </div>
                        <div class="badge badge-info ml-4 v-step-5">
                          {{p.numWindows}} - {{caption("shared_from")}} {{p.firstname}} {{p.lastname}}, {{p.companyName}}
                          <i
                            v-if="getprojreadonly(p.id) == 1"
                            class="fas fa-lock ml-3"
                          ></i>
                          <i v-if="getprojreadonly(p.id) == 0" class="fas fa-lock-open ml-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="p.sharedCount > 0" class="col">
                    <div class="row">
                      <div>
                        <span
                          :class="p.numWindows > 0 ? 'badge badge-primary v-step-5 ml-4' : 'badge badge-danger ml-4 v-step-5'"
                        >{{p.numWindows}}</span>
                        <span class="ml-3" style="color:blue">
                          <small>{{p.customerName}}</small>
                        </span>
                        <span class="ml-1">
                          <strong>{{p.projectName}}</strong>
                        </span>
                        <div class="my-1 ml-4 small">
                          <i class="far fa-plus-square mr-1"></i>
                          {{getDateTime(p.createdDate)}}
                        </div>
                        <div class="my-1 ml-4 small">
                          <i class="far fa-edit mr-1"></i>
                          {{getDateTime(p.lastModifiedDate)}}{{p.lastModifiedUser != p.userId && p.lastModifiedUser != 0 ? ' (' + getuserinfo(p.lastModifiedUser) + ')' : ''}}
                          <i
                            v-if="p.lastModifiedUser == p.userId"
                            class="far fa-user ml-1 mr-1"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div>
                      <template class="row my-2" v-for="sh in shprojects">
                        <div v-bind:key="sh.projectId + sh.userId" class="ml-2 mb-1">
                          <div
                            v-if="sh.projectId == p.id"
                            class="badge badge-pill badge-warning v-step-5"
                          >
                            <i v-if="sh.readonly == 1" class="fas fa-lock mr-2"></i>
                            <i v-if="sh.readonly == 0" class="fas fa-lock-open mr-2"></i>
                            {{getshareduserinfo(sh.userId, sh.readonly)}}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-7 ml-2 ml-lg-0">
                <div class="row mt-3">
                  <div class="col-sm-12 col-xl-6 mb-2">
                    <button
                      v-if="csvloading == false && pdfloading == false"
                      type="button"
                      class="btn btn btn-outline-primary v-step-6"
                      @click="projectBOM(p)"
                    >
                      <i class="far fa-list-alt"></i>
                      <strong>{{caption("winlist_BOM")}}</strong>
                    </button>
                    <button
                      v-if="(csvloading == true && p.id != selProj) || pdfloading == true"
                      type="button"
                      class="btn btn btn-outline-primary disabled"
                    >
                      <i class="far fa-list-alt"></i>
                      <strong>{{caption("winlist_BOM")}}</strong>
                    </button>
                    <button
                      v-if="csvloading == true && p.id == selProj"
                      type="button"
                      class="btn btn btn-outline-primary disabled"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span> Please wait...
                    </button>
                    <button
                      v-if="pdfloading == false && csvloading == false"
                      type="button"
                      class="btn btn btn-outline-success v-step-7"
                      @click="projectPDF(p)"
                    >
                      <i class="far fa-file-pdf fa-lg mr-1"></i>PDF
                    </button>
                    <button
                      v-if="(pdfloading == true && p.id != pdfproj.id) || csvloading == true"
                      type="button"
                      class="btn btn btn-outline-success disabled"
                    >
                      <i class="far fa-file-pdf fa-lg mr-1"></i>PDF
                    </button>
                    <button
                      v-if="pdfloading == true && p.id == pdfproj.id"
                      type="button"
                      class="btn btn btn-outline-success disabled"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {{pdfcaption}} is loading...
                    </button>
                    <span
                      class="btn btn mr-4 btn-outline-primary v-step-8"
                      @click="projectWindows(p)"
                    >
                      <i class="fas fa-city"></i>
                      <strong>{{caption("projlist_Windows")}}</strong>
                    </span>
                  </div>
                  <div class="col-sm-12 col-xl-6">
                    <span
                      v-if="p.sharedCount == null"
                      class="btn btn btn-outline-primary v-step-9"
                      @click="showSharedUsers(p)"
                    >
                      <i class="fas fa-share-alt"></i>
                    </span>
                    <span
                      v-if="p.sharedCount > 0"
                      class="btn btn btn-primary v-step-9"
                      @click="showSharedUsers(p)"
                    >
                      <i class="fas fa-share-alt"></i>
                    </span>
                    <span
                      v-if="p.sharedCount == null || p.sharedCount > 0"
                      class="btn btn btn-outline-primary v-step-10"
                      @click="projectEdit(p.id)"
                    >
                      <i class="fas fa-pen"></i>
                      {{caption("Edit")}}
                    </span>
                    <span
                      v-if="p.sharedCount == 0"
                      class="btn btn btn-outline-primary v-step-10 disabled"
                    >
                      <i class="fas fa-pen"></i>
                      {{caption("Edit")}}
                    </span>
                    <span
                      class="btn btn btn-outline-primary v-step-11"
                      @click="projectCopy(p.id, p.projectName)"
                    >
                      <i class="far fa-copy"></i>
                      {{caption("Copy")}}
                    </span>
                    <span
                      v-if="p.sharedCount == null || p.sharedCount > 0"
                      class="btn btn btn-outline-danger v-step-12"
                      @click="showConfirmDelete(p)"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </span>
                    <span
                      v-if="p.sharedCount == 0"
                      class="btn btn btn-outline-danger v-step-12 disabled"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a id="back-to-top" href="#" class="btn btn-primary btn-lg back-to-top" role="button">
      <i class="fas fa-chevron-up mr-2"></i>Top
    </a>
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from "../../ClientApp/store";
import projectsteps from "../../ClientApp/helpers/project-steps";

//Test

export default {
  data: function() {
    return {
      form: {
        custName: "",
        projName: ""
      },
      error: null,
      projectsloaded: false,
      translationsloaded: false,
      versionsloaded: false,
      searchproj: "",
      selProj: 0,
      stepswithoutENG: projectsteps.stepswithoutENG,
      stepswithENG: projectsteps.stepswithENG,
      stepswithoutCHI: projectsteps.stepswithoutCHI,
      stepswithCHI: projectsteps.stepswithCHI,
      stepswithoutNED: projectsteps.stepswithoutNED,
      stepswithNED: projectsteps.stepswithNED,
      stepswithoutPOR: projectsteps.stepswithoutPOR,
      stepswithPOR: projectsteps.stepswithPOR,
      tour: false,
      myCallbacks: {
        onStart: this.myTourStart,
        onStop: this.myTourStop
      },
      myOptionsNED: {
        labels: {
          buttonSkip: "Verlaat tour",
          buttonPrevious: "Vorige",
          buttonNext: "Volgende",
          buttonStop: "Einde"
        }
      },
      myOptionsENG: {
        labels: {
          buttonSkip: "Skip tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish"
        }
      },
      myOptionsCHI: {
        labels: {
          buttonSkip: "跳过演示说明",
          buttonPrevious: "上一步",
          buttonNext: "下一步",
          buttonStop: "演示结束"
        }
      },
      myOptionsPOR: {
        labels: {
          buttonSkip: "Skip tour",
          buttonPrevious: "Previous",
          buttonNext: "Next",
          buttonStop: "Finish"
        }
      },
      projtodelete: 0,
      bomprojid: null,
      pdfcaption: "PDF",
      pdfproj: null,
      projName: null,
      projId: null,
      projNumWin: null,
      projectNameEmpty: false,
      projusers: [],
      sortoptions: this.$store.getters.getProjectSortOptions,
      firstpage: "1",
      sashpage: "1",
      framepage: "1",
      shulist: null,
      sharedusersloaded: false,
      sharedprojectsloaded: false
    };
  },
  components: {
    AppHeader
  },
  computed: {
    projects() {
      var p = this.$store.getters.getProjects;
      var so = this.$store.getters.getProjectSortOptions;
      if (p != null) {
        var projs = p.filter(p =>
          p.customerName
            .toUpperCase()
            .concat(p.projectName.toUpperCase())
            .includes(this.searchproj.toUpperCase())
        );
        if (so == "newold") {
          projs.sort(function(a, b) {
            if (a.id > b.id) return -1;
            if (a.id < b.id) return 1;
            return 0;
          });
        }
        if (so == "lstmod") {
          projs.sort(function(a, b) {
            if (a.lastModifiedDate > b.lastModifiedDate) return -1;
            if (a.lastModifiedDate < b.lastModifiedDate) return 1;
            return 0;
          });
        }

        if (so == "oldnew") {
          projs.sort(function(a, b) {
            if (a.id < b.id) return -1;
            if (a.id > b.id) return 1;
            return 0;
          });
        }
        if (so == "byName") {
          projs.sort(function(a, b) {
            var nameA =
                a.customerName.toLowerCase() + a.projectName.toLowerCase(),
              nameB =
                b.customerName.toLowerCase() + b.projectName.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        }

        if (this.tour == false) return projs;
        else return projs.slice(0, 1);
      } else return p;
    },
    role() {
      return this.$store.state.auth.role;
    },
    companyName() {
      return this.$store.state.auth.companyName;
    },
    sysco() {
      return this.$store.getters.getAuth.systemCompany;
    },
    usersVN() {
      return this.$store.getters.getAuth.latestVersion;
    },
    latestVN() {
      return this.$store.getters.getLatestVN;
    },
    csvloading() {
      return this.$store.state.csvloading;
    },
    pdfloading() {
      return this.$store.state.pdfloading;
    },
    language() {
      return this.$store.state.language;
    },
    projEmpty() {
      if (this.projectNameEmpty) return true;
      else return false;
    },
    shusers() {
      var selusers = null;
      return this.$store.state.sharedusers;
    },
    shprojects() {
      return this.$store.state.sharedprojects;
    }
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.$store
        .dispatch("getProjectsPerUser", this.$route.params.id)
        .then(response => {
          this.projectsloaded = true;
        });
    } else {
      this.$store.dispatch("getProjects").then(response => {
        this.projectsloaded = true;
      });
    }
    this.$store.dispatch("getVersions").then(response => {
      this.versionsloaded = true;
    });
    this.$store.dispatch("getSharedUsers").then(response => {
      this.sharedusersloaded = true;
    });
    this.$store.dispatch("getSharedProjects").then(response => {
      this.sharedprojectsloaded = true;
    });

    $(document).ready(function() {
      $(window).scroll(function() {
        if ($(this).scrollTop() > 50) {
          $("#back-to-top").show();
        } else {
          $("#back-to-top").hide();
        }
      });
      // scroll body to 0px on click
      $("#back-to-top").click(function() {
        $("#back-to-top").tooltip("hide");
        $("body,html").animate(
          {
            scrollTop: 0
          },
          800
        );
        return false;
      });

      $("#back-to-top").tooltip("show");
    });
  },
  methods: {
    projectCreate: function() {
      this.$router.push("/projectcreate");
    },
    projectEdit: function(id) {
      this.$router.push("/projectedit/" + id);
    },
    projectCopy: function(id, pname) {
      this.projName = pname;
      this.projId = id;
      this.projectNameEmpty = false;
      $("#CopyProjectName").modal("show");
    },
    projCopySend: function() {
      if (this.projName != "") {
        $("#CopyProjectName").modal("hide");
        var payload = { Id: this.projId, ProjectName: this.projName };
        this.$store.dispatch("projectcopy", payload).then(response => {
          this.$store.dispatch("getProjects");
        });
      } else {
        this.projectNameEmpty = true;
      }
    },
    projectDelete: function(id) {
      const payload = {
        Id: id
      };
      this.$store
        .dispatch("projectdelete", payload)
        .then(response => {
          this.$store.dispatch("getProjects");
        })
        .catch(error => {
          if (typeof error.data === "string" || error.data instanceof String) {
            this.errors = {
              error: [error.data]
            };
          } else {
            this.errors = error.data;
          }
        });
    },
    projectWindows: function(proj) {
      this.$store.commit("setProject", proj);
      this.$router.push("/projectwindows/" + proj.id);
    },
    projectBOM: function(proj) {
      this.bomprojid = proj;
      $("#BomSelection").modal("show");
    },
    projectCSV: function(proj) {
      $("#BomSelection").modal("hide");
      this.selProj = proj.id;
      this.$store.dispatch("projectcsv", proj.id);
    },
    projectXL: function(proj) {
      $("#BomSelection").modal("hide");
      this.selProj = proj.id;
      this.$store.dispatch("projectxl", proj.id);
    },
    bommodalhide: function() {
      $("#BomSelection").modal("hide");
    },
    projectPDF: function(proj) {
      this.pdfproj = proj;
      $("#PDFSelection").modal("show");
    },
    projectcopyModalHide: function() {
      $("#CopyProjectName").modal("hide");
    },
    pdfmodalhide: function() {
      $("#PDFSelection").modal("hide");
    },
    selectusershide: function() {
      $("#SharedUsersSelection").modal("hide");
      var pu = { projectId: this.selProj, users: this.projusers };
      this.$store.dispatch("selectusers", pu).then(response => {
        this.$store.dispatch("getProjects").then(response => {
          this.$store.dispatch("getSharedProjects");
        });
      });
    },
    projectPdfSeparate: function() {
      this.$store.commit("setProject", this.pdfproj);
      this.selProj = this.pdfproj.id;
      $("#PDFSelection").modal("hide");
      if (
        this.firstpage != "0" ||
        this.sashpage != "0" ||
        this.framepage != "0"
      ) {
        this.$store.commit("projectPDFRequest");
        var counter = 1;
        this.pdfcaption = "PDF";
        this.$store.dispatch("getwindows", this.pdfproj.id).then(response => {
          var numwin = response.length;
          response.forEach(a => {
            var winname = a.name;
            this.$store
              .dispatch("projectwindowpdf", {
                id: a.id,
                pages: this.firstpage + this.sashpage + this.framepage
              })
              .then(response => {
                this.pdfcaption = counter + " / " + numwin;
                if (counter == numwin) {
                  this.$store.commit("projectPDFSuccess");
                }
                counter = counter + 1;
              });
          });
        });
      }
    },
    projectPdfBundled: function() {
      $("#PDFSelection").modal("hide");
      if (
        this.firstpage != "0" ||
        this.sashpage != "0" ||
        this.framepage != "0"
      ) {
        this.$store.commit("projectPDFRequest");
        this.$store
          .dispatch("projectpdf", {
            proj: this.pdfproj,
            pages: this.firstpage + this.sashpage + this.framepage
          })
          .then(response => {
            this.$store.commit("projectPDFSuccess");
          });
      }
    },
    exportOrgaData: function() {
      this.$store.dispatch("exportOrgaData");
    },
    users: function() {
      this.$router.push("/users");
    },
    caption(term) {
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    },
    versions: function() {
      this.$store.dispatch("setversion");
      this.$router.push("/versions");
    },
    sharedusers: function() {
      this.$router.push("/sharedusers");
    },
    downloads: function() {
      this.$router.push("/downloads");
    },
    starttour: function() {
      this.$tours["ProjectTour"].start();
    },
    cilinder: function() {
      this.$router.push("/cilinders");
    },
    myTourStart: function() {
      this.tour = true;
    },
    myTourStop: function() {
      this.tour = false;
    },
    showConfirmDelete(proj) {
      this.projtodelete = proj;
      $("#ConfirmDelete").modal("show");
    },
    refresh() {
      this.$store.dispatch("getProjects").then(response => {
        this.projectsloaded = true;
      });
    },
    changelanguage: function(lang) {
      this.$store.dispatch("changeLanguage", { l: lang }).then(response => {
        this.$store.dispatch("userLanguage").then(response => {
          this.$store.dispatch("getTranslations");
        });
      });
    },
    showSharedUsers(proj) {
      var pu = [];
      this.$store.dispatch("getProjUsers", proj).then(response => {
        response.data.forEach(function(item) {
          var ro = item.readonly;
          if (ro == 0) pu.push(item.userId + "W");
          if (ro == 1) pu.push(item.userId + "R");
        });
        this.projusers = pu;
        this.selProj = proj.id;
        $("#SharedUsersSelection").modal("show");
      });
    },
    getuserinfo(id) {
      var usr = this.$store.getters.getshareduser(id);
      return usr.firstName + " " + usr.lastName + ", " + usr.companyName;
    },
    getshareduserinfo(id, ro) {
      var usr = this.$store.getters.getshareduserinfo(id, ro);
      if(usr != null){
        return usr.firstName + " " + usr.lastName + ", " + usr.companyName;
      }
      return "";
    },

    usrinlist(id) {
      if (
        this.projusers.includes(id + "W") ||
        this.projusers.includes(id + "R")
      ) {
        return true;
      } else {
        return false;
      }
    },
    readonly(id) {
      if (this.projusers.includes(id + "R")) return 1;
      else if (this.projusers.includes(id + "W")) return 2;
      else return 0;
    },
    setUser(id) {
      if (this.projusers.includes(id + "R")) {
        var i = this.projusers.indexOf(id + "R");
        this.projusers.splice(i, 1);
      } else if (this.projusers.includes(id + "W")) {
        var i = this.projusers.indexOf(id + "W");
        this.projusers.splice(i, 1);
        this.projusers.push(id + "R");
      } else {
        this.projusers.push(id + "W");
      }
    },
    setSort(so) {
      this.sortoptions = so;
      this.$store.commit("setProjectSortOptions", so);
    },
    setfirstpage() {
      if (this.firstpage == "1") {
        this.firstpage = "0";
      } else {
        this.firstpage = "1";
      }
    },
    setsashpage() {
      if (this.sashpage == "1") {
        this.sashpage = "0";
      } else {
        this.sashpage = "1";
      }
    },
    setframepage() {
      if (this.framepage == "1") {
        this.framepage = "0";
      } else {
        this.framepage = "1";
      }
    },
    getDate(dt) {
      var fulldate = JSON.stringify(dt);
      var timeindex = fulldate.indexOf("T");
      var date = fulldate.substring(1, timeindex);

      return date;
    },
    getDateTime(dt) {
      var fulldate = JSON.stringify(dt);
      var timeindex = fulldate.indexOf("T");
      var date = fulldate.substring(1, timeindex);
      var time = fulldate.substring(timeindex + 1, timeindex + 6);
      return date + " " + time;
    },
    getprojreadonly(pid) {
      return this.$store.getters.getprojro(pid);
    }
  }
};
</script>

<style scoped>
@media (min-width: 1500px) {
  .container-fluid {
    width: 80%;
  }
}
@media (min-width: 2000px) {
  .container-fluid {
    width: 60%;
  }
}
.lnk {
  cursor: pointer;
}
.back-to-top {
  cursor: pointer;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/projects/ProjectList.vue